import { currency } from '@shared/hooks/currencies';

export default function rawGetFormattedPrice({
  price,
  business_types,
  showPriceByNight = false,
  showInARS = false,
}) {
  const details = showInARS ? price?.details : price?.details_USD;
  if (!details) {
    return '';
  }

  const isB2B = +business_types?.id === 2;

  if (isB2B) {
    let amountToShow = details.b2b.total;
    if (showPriceByNight) {
      amountToShow = details.b2b.total_usd_night_unrounded;
    }

    return currency(amountToShow, !showInARS);
  }

  let amountToShow = details.total || 0;
  if (showPriceByNight) {
    amountToShow = details.total_usd_night_unrounded;
  }

  return currency(amountToShow, !showInARS);
}
